import type { TaskUser } from '@/task-manager/entities/task-user';

import type { User } from '../fetch-client';

export function taskUserMapper(data: User): TaskUser {
  return {
    name: data.name,
    email: data.email,
    company: data.company,
    guestUser: data.guest_user,
  };
}
